module.exports = __webpack_public_path__ + "img/lianrun04.9ed5e1a8.png";